// extracted by mini-css-extract-plugin
export default {"loading":"feedbackListSearch_loading__-8oPw","pcWrap":"feedbackListSearch_pcWrap__o1yw0"};